import { AuthService } from '@univacity/angular/datas';
import { Menu } from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';

const menus: Menu[] = [
  {
    text: $localize`Dashboard`,
    icon: 'dashboard',
    iconTheme: 'outline',
    link: RoutePath.dashboard,
    pathsMatch: 'exact',
  },
  {
    text: $localize`Applications`,
    icon: 'form',
    iconTheme: 'outline',
    subMenu: [
      {
        text: $localize`Admission`,
        link: RoutePath.dashboardApplications,
        description: $localize`Manage applications for admission.`,
        icon: 'book',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-programs-icon-bg)' },
      },
      {
        text: $localize`Visa`,
        link: RoutePath.dashboardVisaApplications,
        description: $localize`Manage your visa applications.`,
        icon: 'idcard',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-tours-icon-bg)' },
      },
    ],
  },
  {
    text: $localize`Bookings`,
    icon: 'calendar',
    iconTheme: 'outline',
    subMenu: [
      {
        text: $localize`Tours`,
        link: RoutePath.dashboardTourBookings,
        description: $localize`Manage tour bookings`,
        icon: 'environment',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-programs-icon-bg)' },
      },
      // {
      //   text: $localize`Hostel`,
      //   link: RoutePath.dashboardHostelBookings,
      //   description: $localize`Manage your hostel bookings.`,
      //   icon: 'home',
      //   iconTheme: 'fill',
      //   iconStyle: { background: 'var(--sub-menu-tours-icon-bg)' },
      // },
      // {
      //   text: $localize`Flights`,
      //   link: RoutePath.dashboardFlightBookings,
      //   description: $localize`Manage your flights.`,
      //   icon: 'rocket',
      //   iconTheme: 'fill',
      //   iconStyle: { background: 'var(--sub-menu-institutes-icon-bg)' },
      // },
    ],
  },

  {
    text: $localize`Settings`,
    icon: 'setting',
    iconTheme: 'outline',
    link: RoutePath.dashboardSettings,
  },
];

export const getDasboardMenu = (auth: AuthService) => {
  const menu = menus.slice(0);
  if (auth.isStudent) {
    menu.splice(-1, 0, {
      text: $localize`Invoice`,
      link: RoutePath.dashboardInvoices,
      icon: 'calculator',
      iconTheme: 'fill',
    });
  } else {
    menu.splice(-1, 0, {
      text: $localize`Payments`,
      icon: 'calculator',
      iconTheme: 'outline',
      subMenu: [
        {
          text: $localize`Invoices`,
          link: RoutePath.dashboardInvoices,
          description: $localize`View and pay invoices.`,
          icon: 'credit-card',
          iconTheme: 'fill',
          iconStyle: { background: 'var(--sub-menu-programs-icon-bg)' },
        },
        {
          text: $localize`Payments`,
          link: RoutePath.dashboardPayments,
          description: $localize`Pay tuition fee with local currency.`,
          icon: 'wallet',
          iconTheme: 'fill',
          iconStyle: { background: 'var(--sub-menu-tours-icon-bg)' },
        },
        {
          text: $localize`Wallet`,
          link: RoutePath.dashboardWallet,
          description: $localize`View and withdraw balance.`,
          icon: 'wallet',
          iconTheme: 'fill',
          iconStyle: { background: 'var(--sub-menu-tours-icon-bg)' },
        },
      ],
    });
  }
  return menu;
};
